module.exports = __webpack_public_path__ + "img/support_a1.e7395bc7.png";